import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { SEO } from "@/components/common/SEO";
import SmartImage from "@/components/common/SmartImage";
export default function News() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/articles").then((r)=>setItems(r.data)); }, []);
  return (<div className="max-w-7xl mx-auto px-6 lg:px-10 py-12" data-testid="news-page">
    <SEO title="Smart Auto News" description="AI-summarised news for Indian car buyers."/>
    <div className="text-xs uppercase tracking-[0.2em] text-muted-foreground">Smart News</div>
    <h1 className="font-display text-4xl sm:text-5xl mt-2 tracking-tighter">Read in 30 seconds.</h1>
    <div className="mt-10 grid md:grid-cols-2 gap-6">{items.map((a)=>(
      <Link key={a.slug} to={`/news/${a.slug}`} data-testid={`news-item-${a.slug}`} className="rounded-3xl overflow-hidden border border-border bg-card/30 hover:border-foreground/30 transition-all group">
        <div className="aspect-[16/9] overflow-hidden"><SmartImage src={a.hero_image} alt={a.title} label={a.title} className="group-hover:scale-[1.03] transition-transform"/></div>
        <div className="p-6">
          <div className="text-xs uppercase tracking-[0.2em] text-muted-foreground">{a.category} · {a.read_minutes} min</div>
          <div className="font-display text-2xl tracking-tight leading-snug mt-2">{a.title}</div>
          <p className="text-sm text-muted-foreground mt-3 line-clamp-2">{a.excerpt}</p>
          {a.ai_summary && (<div className="mt-4 rounded-2xl border border-border bg-secondary/30 p-3"><div className="text-xs uppercase tracking-[0.2em] text-ai font-semibold mb-1">AI Summary</div><div className="text-sm">{a.ai_summary}</div></div>)}
        </div>
      </Link>))}</div>
  </div>);
}
